module.exports = __webpack_public_path__ + "static/3-9f9084ad5f33c5e3927975c9fe3d7b8c.jpg";